import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  activateInvitationLink,
  deactivateInvitationLink,
  deleteInvitationLink,
} from "~/providers/api/consultationLinks";
import { invitationLinksQueryOptionsFactory } from "~/providers/factories/invitationLinksQueryOptionsFactory";
import { useCurrentTeamMemberContext } from "../useCurrentTeamMemberContext";

export const useInvitationLinks = () => {
  const teamMember = useCurrentTeamMemberContext();

  const organizationId =
    teamMember.organization_team_members[0].organization_id;

  return useQuery(invitationLinksQueryOptionsFactory.list({ organizationId }));
};

export const useDeleteInvitationLink = (closeModal?: () => void) => {
  const queryClient = useQueryClient();
  const teamMember = useCurrentTeamMemberContext();

  const organizationId =
    teamMember.organization_team_members[0].organization_id;

  return useMutation({
    mutationFn: (invitationId?: string) =>
      deleteInvitationLink({
        invitationId,
        organizationId,
      }),
    onSuccess: async () => {
      closeModal?.();
      await queryClient.invalidateQueries({
        queryKey: invitationLinksQueryOptionsFactory.list._def,
      });
      toast.success("Link deleted successfully");
    },
  });
};

export const useActivateInvitationLink = (closeModal?: () => void) => {
  const queryClient = useQueryClient();
  const teamMember = useCurrentTeamMemberContext();

  const organizationId =
    teamMember.organization_team_members[0].organization_id;

  return useMutation({
    mutationFn: (invitationId?: string) =>
      activateInvitationLink({
        invitationId,
        organizationId,
      }),
    onSuccess: async () => {
      closeModal?.();
      await queryClient.invalidateQueries({
        queryKey: invitationLinksQueryOptionsFactory.list._def,
      });
      toast.success("Link activated successfully");
    },
  });
};

export const useDeactivateInvitationLink = (closeModal?: () => void) => {
  const queryClient = useQueryClient();
  const teamMember = useCurrentTeamMemberContext();

  const organizationId =
    teamMember.organization_team_members[0].organization_id;

  return useMutation({
    mutationFn: (invitationId?: string) =>
      deactivateInvitationLink({
        invitationId,
        organizationId,
      }),
    onSuccess: async () => {
      closeModal?.();
      await queryClient.invalidateQueries({
        queryKey: invitationLinksQueryOptionsFactory.list._def,
      });
      toast.success("Link deactivated successfully");
    },
  });
};
